import { USER_SIGN_IN_SUCCESS} from "Store/constants";
function FileSelector(UIExtension, emitter, mountedCallback, onClickCallback) {
  function addListener(event, handler) {
    emitter.on(event, handler);
    return () => {
      emitter.removeListener(event, handler);
    };
  }
  //UIExtension.components.widgets.FileSelectorComponent
  let module = UIExtension.modular.module('online');
  // template: '<online:file-selector></online:file-selector>'
  //!FileSelectorComponent定义文件选择器组件
  //!对应文档:https://developers.foxit.com/resources/pdf-sdk-web/api_reference/class_file_selector_component.html
  class FileSelectorComponentEx extends UIExtension.components.widgets.FileSelectorComponent {
      // static getName() {
          //     return 'file-selector';
          // }
          
    onClick = (e) => {
        onClickCallback && onClickCallback(this, e);
    };
    disableClick = (e) =>{
      e && e.preventDefault();
    }
    mounted() {
      super.mounted();

      mountedCallback && mountedCallback(this);
      this.addDestroyHook(
        addListener(USER_SIGN_IN_SUCCESS, () => {
          mountedCallback && mountedCallback(this);
        }),
      );
    }

    doEnableNoticeClick = () => {
      //this.inputElement.setAttribute('disabled', 'disabled');
      //this.inputElement.classList.add('disabled')
      this.inputElement.addEventListener('click', this.disableClick);
      this.labelElement.addEventListener('click', this.onClick);
      this.addDestroyHook(() => {
        this.inputElement.removeEventListener('click', this.disableClick);
        this.labelElement.removeEventListener('click', this.onClick);
      });
    }
    doEnableInput = () => {
      //this.inputElement.removeAttribute('disabled');
      //this.inputElement.classList.remove('disabled')
      this.inputElement.removeEventListener('click', this.disableClick);
      this.labelElement.removeEventListener('click', this.onClick);
    }
  }
  //!registerComponent注册组件
  //!对应文档:https://developers.foxit.com/resources/pdf-sdk-web/api_reference/class_u_i_x_module.html#a8efe95db8017afda4835323d6757f64f
  module.registerComponent(FileSelectorComponentEx);
}

export default FileSelector;
